import React from "react";
import { KDM_STATS, FLAGSHIP_BRANDS } from "../../data/kdm";
import Reveal from "../Reveal";

export default function StatsStrip() {
  return (
    <section data-testid="stats-section" className="relative bg-[--kdm-bg-alt] border-y border-[--kdm-line]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 lg:py-20 grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6">
        {KDM_STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 80} className="flex flex-col">
            <span className="font-serif text-5xl lg:text-6xl text-[--kdm-ink] tracking-tight">
              {s.value}
            </span>
            <span className="kdm-divider mt-4" />
            <span className="overline mt-5 !text-[--kdm-ink-soft] !font-medium">
              {s.label}
            </span>
          </Reveal>
        ))}
      </div>

      {/* Brand marquee */}
      <div className="overflow-hidden border-t border-[--kdm-line] py-6 bg-white">
        <div className="marquee-track" data-testid="brand-marquee">
          {[...FLAGSHIP_BRANDS, ...FLAGSHIP_BRANDS].map((b, idx) => {
            const Tag = b.href ? "a" : "span";
            return (
              <Tag
                key={`${b.label}-${idx}`}
                href={b.href}
                target={b.href ? "_blank" : undefined}
                rel={b.href ? "noopener noreferrer" : undefined}
                className={`text-xs tracking-[0.32em] font-medium whitespace-nowrap transition-colors duration-300 ${
                  b.href ? "text-[--kdm-ink] hover:text-gold cursor-pointer" : "text-[--kdm-ink-soft]"
                }`}
              >
                {b.label} <span className="text-gold mx-2">◆</span>
              </Tag>
            );
          })}
        </div>
      </div>
    </section>
  );
}
